import axios from "axios";
import {uuid} from "@/utils";
import Config from "@/config"

export default {
  axios: axios.create({
    baseURL: `${Config.API_URL}/api`,
    withCredentials: false, // This is the default
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${Config.JWT_TOKEN}`
    },
    timeout: 10000
  }),
  id: uuid() // Make sure we have singleton
};
